import React, { useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import portfolioImg1 from '../assets/img/protfolio1.png'
import portfolioImg2 from '../assets/img/portfolio2.png'
import portfolioImg3 from '../assets/img/portfolio3.png'
import portfolioImg4 from '../assets/img/portfolio4.png'
import portfolioImg5 from '../assets/img/portfolio5.png'
import portfolioImg6 from '../assets/img/portfolio6.png'
import portfolioImg7 from '../assets/img/portfolio7.png'
// Import Swiper styles
 import "swiper/css";
 import "swiper/css/navigation";
 import "swiper/css/pagination";
import { Navigation, Pagination, Mousewheel, Keyboard } from "swiper";
const Portfolio = () => {
    const [_, setInit] = useState();
    const prevRef = useRef(null);
    const nextRef = useRef(null);
  return (

    <>
      <section className="portfolio section" id="portfolio">
        <h2 className="section__title">Portfolio</h2>
        <span className="section__subtitle">Most recent work</span>

        <Swiper
          cssMode={true}
          loop={true}
          pagination={{
            clickable: true,
          }}
          navigation={{
            prevEl: prevRef.current,
            nextEl: nextRef.current,
          }}
          mousewheel={true}
          keyboard={true}
          onInit={() => setInit(true)}
          modules={[Navigation, Pagination, Mousewheel, Keyboard]}
          className="mySwiper portfolio__container container"
        >
           <SwiperSlide>
          <div className="portfolio__content grid">
            <img
              src={portfolioImg2}
              alt=""
              className="portfolio__img"
            />

            <div className="portfolio__data">
              <h3 className="portfolio__title">Restaurant Website</h3>
              <p className="portfolio__description">
                A website developed using React having feature like dark mode
              </p>
              <a
                href="https://techrestaurantrenuka.netlify.app/"
                rel="noreferrer"
                 target={"_blank"} 
                className="button button--flex button--small portfolio__button"
              >
                Demo <i className="uil uil-arrow-right button__icon"></i>
              </a>
            </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
          <div className="portfolio__content grid">
            <img
              src={portfolioImg7}
              alt=""
              className="portfolio__img"
            />

            <div className="portfolio__data">
              <h3 className="portfolio__title">E-commerce Website</h3>
              <p className="portfolio__description">
                A website developed using React and React Redux having feature like dark mode
              </p>
              <a
                href="https://watchshoprenuka.netlify.app/"
                rel="noreferrer"
                 target={"_blank"} 
                className="button button--flex button--small portfolio__button"
              >
                Demo <i className="uil uil-arrow-right button__icon"></i>
              </a>
            </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="portfolio__content grid">
            <img
              src={portfolioImg4}
              alt=""
              className="portfolio__img"
            />

            <div className="portfolio__data">
              <h3 className="portfolio__title">Portfolio Website</h3>
              <p className="portfolio__description">
                My own portfolio website developed with React Js having features like Email and Dark mode.
              </p>
              <a
                 href="/"
                 rel="noreferrer"
                 target={"_blank"}  
                className="button button--flex button--small portfolio__button"
              >
                Demo <i className="uil uil-arrow-right button__icon"></i>
              </a>
            </div>
            </div>
           
          </SwiperSlide>
          <SwiperSlide>
            <div className="portfolio__content grid">
            <img
              src={portfolioImg5}
              alt=""
              className="portfolio__img"
            />

            <div className="portfolio__data">
              <h3 className="portfolio__title">Flight Reservation</h3>
              <p className="portfolio__description">
                Website created using Springboot as Back-end with MySQL and React as Front-end
              </p>
              <a
                 href="https://github.com/renuka-rathva/flightbookingUI"
                 rel="noreferrer"
                 target={"_blank"}  
                className="button button--flex button--small portfolio__button"
              >
                Demo <i className="uil uil-arrow-right button__icon"></i>
              </a>
            </div>
            </div>
           
          </SwiperSlide>
          <SwiperSlide>
            <div className="portfolio__content grid">
            <img
              src={portfolioImg6}
              alt=""
              className="portfolio__img"
            />

            <div className="portfolio__data">
              <h3 className="portfolio__title">Employee Management</h3>
              <p className="portfolio__description">
                Website created using Springboot as Back-end with MySQL and React as Front-end
              </p>
              <a
                 href="https://github.com/renuka-rathva/Employee-System-UI"
                 rel="noreferrer"
                 target={"_blank"}  
                className="button button--flex button--small portfolio__button"
              >
                Demo <i className="uil uil-arrow-right button__icon"></i>
              </a>
            </div>
            </div>
           
          </SwiperSlide>

          <SwiperSlide>
            <div className="portfolio__content grid">
            <img
              src={portfolioImg1}
              alt=""
              className="portfolio__img"
            />

            <div className="portfolio__data">
              <h3 className="portfolio__title">Keep notes</h3>
              <p className="portfolio__description">
                Website to save notes, developed with Javascript and Bootstrap framework
              </p>
              <a
                 href="https://keepnotesrenuka.netlify.app/"
                 rel="noreferrer"
                 target={"_blank"}  
                className="button button--flex button--small portfolio__button"
              >
                Demo <i className="uil uil-arrow-right button__icon"></i>
              </a>
            </div>
            </div>
           
          </SwiperSlide>
         
       
          <SwiperSlide>
            
          <div className="portfolio__content grid">
            <img
              src={portfolioImg3}
              alt=""
              className="portfolio__img"
            />

            <div className="portfolio__data">
              <h3 className="portfolio__title">Landing Page</h3>
              <p className="portfolio__description">
              Landing page for techgear using Bootrap framework
              </p>
              <a
                href="https://teachgearrenuka.netlify.app/"
                rel="noreferrer"
                 target={"_blank"} 
                className="button button--flex button--small portfolio__button"
              >
                Demo <i className="uil uil-arrow-right button__icon"></i>
              </a>
            </div>
            </div>
          </SwiperSlide>
          <div className="swiper-button-next" ref={nextRef}>
            <i className="uil uil-angle-right-b swiper-portfolio-icon"></i>
          </div>
          <div className="swiper-button-prev"  ref={prevRef}>
            <i className="uil uil-angle-left-b swiper-portfolio-icon"></i>
          </div>
          {/* <div className="swiper-pagination swiper-pagination-port"></div> */}
        </Swiper>
       
      
      </section>
    </>
  );
};

export default Portfolio;
